import React, {Component} from 'react';
import {NavLink} from 'react-router-dom';
import Context from '../context';
import { FormattedMessage } from 'react-intl';


import './adminTemplate/css/bootstrap.css';
import './adminTemplate/css/mdb.css';
import './adminTemplate/css/style.css';

class sideBar extends Component {



    render() {
        let sideBarAdmin = null;
        let sideBarUser = null;
        let sideBarSpecial = null;

        sideBarAdmin = (
                <div className="list-group list-group-flush mt-6">
                    <i><FormattedMessage id="admin" /></i>
                    <NavLink to='/dashboard' className="list-group-item list-group-item-action waves-effect"
                             activeClassName="active">
                        <i className="fas fa-chart-pie mr-3"/><FormattedMessage id="admin2" />
                    </NavLink>
                    <NavLink to='/configurations' className="list-group-item list-group-item-action waves-effect"
                             activeClassName="active">
                        <i className="fas fa-chart-pie mr-3"/><FormattedMessage id="configs" />
                    </NavLink>
                    <NavLink to='/permissions' className="list-group-item list-group-item-action waves-effect"
                             activeClassName="active">
                        <i className="fas fa-chart-pie mr-3"/><FormattedMessage id="permissions" />
                    </NavLink>
                </div>
        );

        sideBarUser = (
                <div className="list-group list-group-flush mt-6">
                    <i><FormattedMessage id="user"/></i>
                    <NavLink to='/' exact className="list-group-item list-group-item-action waves-effect"
                             activeClassName="active">
                        <i className="fas fa-map mr-3"/><FormattedMessage id="home"/>
                    </NavLink>
                    <NavLink to="/rgpd" className="list-group-item list-group-item-action waves-effect"
                             activeClassName="active">
                        <i className="fas fa-money-bill-alt mr-3"/>RGPD
                    </NavLink>
                    <i><FormattedMessage id="studies" /></i>
                    <NavLink to="/codes" className="list-group-item list-group-item-action waves-effect"
                             activeClassName="active">
                        <i className="fas fa-money-bill-alt mr-3"/>E-cuidHaMUs
                    </NavLink>
                    <NavLink to="#" className="list-group-item list-group-item-action waves-effect"
                             activeClassName="active">
                        <i className="fas fa-money-bill-alt mr-3"/><FormattedMessage id="others"/>
                    </NavLink>
                    <i><FormattedMessage id="studieParticipation"/></i>
                    <NavLink to="/usability" className="list-group-item list-group-item-action waves-effect"
                             activeClassName="active">
                        <i className="fas fa-money-bill-alt mr-3"/><FormattedMessage id="usability"/>
                    </NavLink>
                    <NavLink to="#" className="list-group-item list-group-item-action waves-effect"
                             activeClassName="active">
                        <i className="fas fa-money-bill-alt mr-3"/><FormattedMessage id="studie2"/>
                    </NavLink>
                    <i><FormattedMessage id="privateArea"/></i>
                    <NavLink to="/suggestions" className="list-group-item list-group-item-action waves-effect"
                             activeClassName="active">
                        <i className="fas fa-money-bill-alt mr-3"/><FormattedMessage id="suggestions"/>
                    </NavLink>
                    <NavLink to="/profile" className="list-group-item list-group-item-action waves-effect"
                             activeClassName="active">
                        <i className="fas fa-money-bill-alt mr-3"/><FormattedMessage id="profile"/>
                    </NavLink>
                </div>
            );

        sideBarSpecial=(
            <div className="list-group list-group-flush mt-6">
                <i>Special</i>
                <NavLink to='/admin' className="list-group-item list-group-item-action waves-effect"
                         activeClassName="active">
                    <i className="fas fa-user mr-3"/>Inserir questionário
                </NavLink>
                <NavLink to='/editCodes'
                         className="list-group-item list-group-item-action waves-effect"
                         activeClassName="active">
                    <i className="fas fa-table mr-3"/>Editar questionários
                </NavLink>
            </div>
        );

        const _renderContent = (context) => {
            if(context.sideBarUserBool) return sideBarUser;
            if(context.sideBarAdminBool) return sideBarAdmin;
            if(context.sideBarSpecialBool) return sideBarSpecial;
            return false;
        };

        return (
            <div>
                <Context.Consumer>
                    {(context) => {
                        return _renderContent(context.state);

/*                        if(context.state.sideBarUserBool){
                            {sideBarUser}
                        }
                        else if(context.state.sideBarUserBool){
                            {sideBarAdmin}
                        }
                        else{
                            {sideBarSpecial}
                        }*/
                    }}
                </Context.Consumer>
            </div>
        )
    };
}
export default sideBar;



// WEBPACK FOOTER //
// ./src/components/sideBar.js